import React, { useState } from "react";
import { IconButton } from "@chakra-ui/react";
import { CopyIcon, CheckIcon } from "@chakra-ui/icons";

const Clipboard = ({ value }) => {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopyClick = () => {
    navigator.clipboard.writeText(value);
    setIsCopied(true);
    setTimeout(() => {
      setIsCopied(false);
    }, 2000);
  };

  return (
    <IconButton
      position="absolute"
      top="0.5rem"
      right="0.5rem"
      onClick={handleCopyClick}
      aria-label="Copy code"
      marginLeft="1rem"
      background="#303a52"
      _hover={{
        background: "transparent",
      }}
      size="sm"
      icon={isCopied ? <CheckIcon /> : <CopyIcon />}
    />
  );
};

export default Clipboard;
